module.exports = __webpack_public_path__ + "static/media/tezos-sym.c6a20d86.svg";